import * as React from "react";
import { Base } from "../../framework/base";
import { EventState, EventUserState } from "../../models/enums";
import { Translations } from "../../models/translations";
import { EventListStateChip } from "./eventListStateChip";

interface IEventListStateColItem {
    isRead: boolean;
    userState: EventUserState;
    imported: boolean;
    exported: boolean;
    locked: boolean;
    state: EventState;
    stateStr: string;
    urgencyClassCode: string;
    urgencyClassColor: string;

    getModifyDate(): number;
}

interface IEventListStateColProp {
    reverse?: boolean;
    item: IEventListStateColItem;
}

export const EventListStateCol = (props: IEventListStateColProp) => {
    const nowDate = Date.now();
    const item = props.item;
    return (
        <div className={"flex WithIcons jend" + (props.reverse ? " reverse" : "")}>
            {!props.reverse && !item.isRead &&
                <span className="icon newItem" title={Translations.Unread}></span>
            }
            <EventListStateChip
                state={item.state}
                stateText={item.stateStr}
            />
            <span className="icon svg" title={Translations.EventUrgencyClass + ": " + item.urgencyClassCode}>
                <svg xmlns="http://www.w3.org/2000/svg" role="img" width="512" height="512" viewBox="0 0 512 512">
                    <rect width="100%" height="100%" fill="none"/>
                    <g className="currentLayer"><path d="M506.3 417 293 53c-16.33-28-57.54-28-73.98 0L5.82 417c-16.41 27.9 4.029 63 36.92 63h426.6c32.76 0 53.26-35 36.96-63zM232 168c0-13.25 10.75-24 24-24s24 10.8 24 24v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zm24 248c-17.36 0-31.44-14.08-31.44-31.44s14.07-31.44 31.44-31.44 31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z" fill={item.urgencyClassColor} /></g>
                </svg>
            </span>
            {item.userState === EventUserState.NotApproved &&
                <span className="icon approved red" title={Translations.EventIsNotApprovedByUser}></span>
            }
            {item.userState === EventUserState.Approved &&
                <span className="icon approved" title={Translations.EventIsApprovedByUser}></span>
            }
            {item.imported &&
                <span className="icon imported" title={Translations.EventSenderIsPartnerCompany}></span>
            }
            {item.exported &&
                <span className="icon exported" title={Translations.EventReceiverIsPartnerCompany}></span>
            }
            {(nowDate - item.getModifyDate()) <= Base.oneHourInMs &&
                <span className="icon fresh" title={Translations.RecentlyUpdated}></span>
            }
            {item.locked &&
                <span className="icon locked" title={Translations.Locked}></span>
            }
            {!!props.reverse && !item.isRead &&
                <span className="icon newItem" title={Translations.Unread}></span>
            }
        </div>
    );
};
